var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { ButtonBase } from "@mui/material";
var ToolbarButton = forwardRef(function ToolbarButton(_a, ref) {
    var children = _a.children, onClick = _a.onClick, disabled = _a.disabled, _b = _a.active, active = _b === void 0 ? false : _b, sx = _a.sx, ariaLabel = _a.ariaLabel;
    return (_jsx(ButtonBase, { ref: ref, onClick: onClick, disabled: disabled, "aria-label": ariaLabel, className: active ? "is-active" : "", sx: __assign({ display: "inline-flex", alignItems: "center", justifyContent: "center", whiteSpace: "nowrap", height: 32, minWidth: 32, px: "8px", fontSize: 14, fontWeight: 500, cursor: "pointer", borderRadius: "6px", color: "rgba(255, 255, 255, 0.8)", backgroundColor: active ? "rgba(255, 184, 1, 0.12)" : "rgba(255, 255, 255, 0.04)", border: active ? "1px solid rgb(255, 184, 1)" : "1px solid rgba(255, 255, 255, 0.12)", transition: "all 200ms ease", "&:hover": {
                backgroundColor: active ? "rgba(255, 184, 1, 0.18)" : "rgba(255, 255, 255, 0.08)",
                borderColor: "rgb(255, 184, 1)",
                color: "#fff",
            }, "&.Mui-disabled": {
                opacity: 0.4,
                pointerEvents: "none",
            } }, sx), children: children }));
});
export default ToolbarButton;
